import { render, staticRenderFns } from "./orderDetailsModal.vue?vue&type=template&id=49389050&"
import script from "./orderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./orderDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailsModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports